export default __webpack_public_path__ + "static/media/Elysee-Palace.218dd205.png";